<template>
  <div id="app">
    <router-view />
    <my-footer class="footer"></my-footer>
  </div>
</template>

<script>
import MyFooter from "@/components/footer";
export default {
  components: {
    MyFooter
  }
};
</script>

<style lang="scss">
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: url("~@/assets/bg.jpg") no-repeat center top;
  @media screen and (max-width: 960px) {
    background: #b4d8f3 url("~@/assets/bg-mobile.jpg") no-repeat center top /
      100% auto;
  }
  .footer {
    margin-top: auto;
  }
}
</style>
